import { TeachersToolkitLanding } from "./TeachersToolkit/TeachersToolkitLanding/TeachersToolkitLanding";
import { SolarSchoolsTheme } from "./utilities/Theme/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import ReactDOM from "react-dom";
import React from "react";

const init = async (api) => {
  const element = document.getElementById("teachers-toolkit");

  if (!element) {
    return;
  }

  try {
    const { defaultResource: { resourceType, resourceId } = {} } =
      typeof user !== "undefined" ? user : {};
    let schoolSlug = null;

    if (resourceId && ["organisations", "sites"].includes(resourceType)) {
      const { slug = null } = await api.call(resourceType, "get", [resourceId]);
      schoolSlug = slug;
    }

    document.title = `Teachers Toolkit`;
    ReactDOM.render(
      <ThemeProvider theme={SolarSchoolsTheme}>
        <TeachersToolkitLanding schoolSlug={schoolSlug} />
      </ThemeProvider>,
      element
    );
  } catch (err) {
    console.error(err);
  }
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/teachersToolkit.js